import Layout from '@layout/Index'

export const paymentManager = [
  {
    path: '/payment-manager',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "payment-manager-table" */ './pages/PaymentManagerTable.vue'),
        meta: {
          title: '付款申请列表',
          type: 'table',
        },
      },
      {
        path: 'approval',
        component: () => import(/* webpackChunkName: "payment-manager-table" */ './pages/PaymentManagerTable.vue'),
        meta: {
          title: '付款申请待审批列表',
          type: 'approval',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "payment-manager-form" */ './pages/PaymentManagerForm.vue'),
        meta: {
          title: '添加付款申请',
        },
      },
      {
        path: 'bach-create',
        component: () => import(/* webpackChunkName: "payment-manager-form-batch" */ './pages/PaymentManagerForm.vue'),
        meta: {
          isBatch: true,
          title: '发起批量付款申请',
        },
      },
      {
        path: 'detail-redirect/:id',
        component: () => import(/* webpackChunkName: "payment-manager-detail-redirect" */ './pages/PaymentManagerDetailRedirect.vue'),
        meta: {
          title: '付款详情跳转页',
        },
      },
      {
        path: 'review/:id',
        component: () => import(/* webpackChunkName: "payment-manager-review" */ './pages/PaymentManagerReview.vue'),
        meta: {
          isReview: true,
          title: '付款申请详情',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "payment-manager-update" */ './pages/PaymentManagerForm.vue'),
        meta: {
          title: '修改付款申请',
        },
      },
      {
        path: 'batch-update/:id',
        component: () => import(/* webpackChunkName: "payment-manager-update-batch" */ './pages/PaymentManagerForm.vue'),
        meta: {
          isBatch: true,
          title: '修改批量付款申请',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "payment-manager-detail" */ './pages/PaymentManagerReview.vue'),
        meta: {
          title: '付款申请详情',
        },
      },
      {
        path: 'write-off/create/:id',
        component: () => import(/* webpackChunkName: "payment-manager-detail" */ './pages/PaymentManagerWriteOff.vue'),
        meta: {
          title: '冲销申请',
        },
      },
      {
        path: 'write-off/update/:id',
        component: () => import(/* webpackChunkName: "payment-manager-detail" */ './pages/PaymentManagerWriteOff.vue'),
        meta: {
          title: '冲销申请',
          isUpdate: true,
        },
      },
      {
        path: 'write-off/review/:id',
        component: () => import(/* webpackChunkName: "payment-manager-detail" */ './pages/PaymentManagerWriteOff.vue'),
        meta: {
          title: '冲销申请',
          isReview: true
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/payment-manager/payment-manager.route.js